import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-col items-center justify-center p-8 text-center bg-white rounded-xl border border-gray-200 border-dashed" data-id="element-2310">
      <div className="h-16 w-16 bg-gray-50 rounded-full flex items-center justify-center mb-4" data-id="element-2311">
        <Icon className="h-8 w-8 text-gray-400" data-id="element-2312" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-2313">{title}</h3>
      <p className="text-sm text-gray-500 max-w-sm mb-6" data-id="element-2314">{description}</p>
      {action && <button onClick={action.onClick} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" data-id="element-2315">
          {action.label}
        </button>}
    </motion.div>;
}